import { Link } from 'react-router-dom';
import Tab from 'components/common/Tab';

interface AdminPageNavigationProps {
  currentPage: 'survey-logs';
}

const AdminPageNavigation = ({ currentPage }: AdminPageNavigationProps) => {
  return (
    <div className="flex items-end space-x-4 text-sm mt-6 mb-4 border-b border-light-grey">
      <Link to="/admin">
        <Tab isActive={currentPage === 'survey-logs'}>
          <span>Survey Logs</span>
        </Tab>
      </Link>
    </div>
  );
};

export default AdminPageNavigation;
